import { useMutation } from "@apollo/client/react";
import { MERGE_INVOICE_UPLOAD_DOCUMENTS } from "../../mutations/documentHandler/mergeInvoiceUploadDocuments";
import GET_ALL_UPLOAD_UNITS from "../../queries/documentHandler/getAllUploadUnits";
import GET_CLIENTS_WITH_UPLOAD_UNITS from "../../queries/documentHandler/getClientsWithUploadUnits";

export const useMergeInvoiceUploadDocuments = ({
  onCompleted,
  onError,
}: {
  onCompleted: (result: any) => void;
  onError: () => void;
}) => {
  const [mergeInvoiceUploadDocuments, { data, loading, error }] = useMutation(
    MERGE_INVOICE_UPLOAD_DOCUMENTS,
    {
      onCompleted: onCompleted,
      onError: onError,
      refetchQueries: [GET_ALL_UPLOAD_UNITS, GET_CLIENTS_WITH_UPLOAD_UNITS],
      awaitRefetchQueries: true,
    },
  );

  return { mergeInvoiceUploadDocuments, data, loading, error };
};
